export default {
  header: "Welcome to Monster Maker!",
  view: "home",
  monster: [],
  monsters: [],
  monsterIndex: 0,
  monsterCount: 1
};
